/* eslint-disable import/prefer-default-export */
import * as coreUI from './core-ui-actions';

export function getTypes() {
    return dispatch => {
        const promises = [
            dispatch(coreUI.fetchTypes()),
            dispatch(coreUI.fetchSearchTypes()),
        ];
        // eslint-disable-next-line no-unused-vars
        const promisesResolved = promises.map(promise => promise.catch(error => undefined));
        return Promise.all(promisesResolved);
    };
}
